import React, {useEffect, useRef} from "react";
import {Button} from "@mui/material";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import ConditionalComponent from "./ConditionalComponent";

const DraggableInput = observer(props => {
    const {generalStore, modalStore} = useStores();

    const dropRef = useRef(null);
    const imageUploader = useRef(null);
    const maxFiles = props.inputMaxFiles? props.inputMaxFiles  : 10
    const fileTypes = props.inputFileTypes ? props.inputFileTypes : generalStore.oldMediaFileToBeReplaced ? 'image/*, video/*, .pdf' : '*'
    let dragCounter = 0;
    

    useEffect(() => {
        const div = dropRef.current;
        div.addEventListener('dragenter', handleDragIn);
        div.addEventListener('dragleave', handleDragOut);
        div.addEventListener('dragover', handleDrag);
        div.addEventListener('drop', handleDrop);

        return () => {
            div.removeEventListener('dragenter', handleDragIn);
            div.removeEventListener('dragleave', handleDragOut);
            div.removeEventListener('dragover', handleDrag);
            div.removeEventListener('drop', handleDrop)
        }
        // eslint-disable-next-line
    }, [dropRef.current])

    function handleDragIn(e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter++;
        props.onDragStart();
    }

    function handleDragOut(e) {
        e.preventDefault();
        e.stopPropagation();

        dragCounter--;
        if (dragCounter > 0) return;

        props.onDragStop();
    }

    function handleDrag(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        const files = Array.from(e.dataTransfer.files);
        if (files.length > maxFiles) {
            modalStore.showErrorMessage(`You can only select up to ${maxFiles} files.`)
            e.dataTransfer.value = '';
            return;
        }
        let filteredFiles = e.dataTransfer.files;
        if (fileTypes !== '*') {
            const fileTypesArray = fileTypes.split(',').map(ft => ft.replace('/*', '').replace(/\s+/g, ''));
            filteredFiles = files.filter(file => {
                for (let type of fileTypesArray) {
                    if (file.type.includes(type) || file.name.endsWith(type)) {
                        return true;
                    } 
                }
                return false;
            })
            if (filteredFiles.length === 0) {
                modalStore.showErrorMessage(`Files types are invalid or unsupported.`)
                e.dataTransfer.value = '';
                return;
            }

        }

        props.onDragStop();
        props.onInputSelected(filteredFiles);
    }

    return (
        <div className='draggable-input-body' ref={dropRef}>
            <div className='cover'/>
            <ConditionalComponent if={props.style === 'guides'}>
                <div className = {`${props.textHeight ? 'h-[100%]' : 'h-[100%]'}  flex flex-col  items-center`} >
                    <div className="font-bold items-center flex flex-col gap-1">
                        <div>
                            Drag & Drop
                        </div>
                        <div>
                            OR
                        </div>
                        <div>
                            <Button onClick={() => imageUploader.current.click()} variant='text' sx={{ fontWeight: 'bold',  textTransform: 'none !important', padding: '0px ', fontSize: '16px !important',color: '#1976d2 !important', }}>
                                Browse
                            </Button>
                        </div>
                    </div>
                    {props.additionalInformation? props.additionalInformation : <></>}
                </div>
            </ConditionalComponent>
            <ConditionalComponent if={props.style !== 'guides'}>
                <div>
                    {generalStore.translate('dragDropFilesHere')}
                </div>
                <div>
                    {generalStore.translate('or')}
                </div>
                <div>
                    <Button onClick={() => imageUploader.current.click()} variant='contained' color='primary'>
                        {generalStore.translate('uploadFromComputer')}
                    </Button>
                </div>
            </ConditionalComponent>

            <div>

            </div>
            <input
                multiple
                type="file"
                accept={fileTypes}
                ref={imageUploader}
                style={{display: 'none'}}
                onChange={e => {
                    const files = Array.from(e.target.files);

                    if (files.length > maxFiles) {
                        modalStore.showErrorMessage(`You can only select up to ${maxFiles} files.`)
                        e.target.value = '';
                        return;
                    }

                    props.onInputSelected(e.target.files)
                }}
            />
        </div>
    );
});

DraggableInput.propTypes = {
    onInputSelected: PropTypes.func.isRequired,
    onDragStart: PropTypes.func,
    onDragStop: PropTypes.func
}

export default DraggableInput;
